import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loading } from '../components/common';
import { PATHS } from './paths';

interface PrivateRouteProps {
  roles?: string[];
}

export function PrivateRoute({ roles }: PrivateRouteProps) {
  const { isAuthenticated, isLoading, hasPermission } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <Loading fullScreen message="Carregando..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to={PATHS.LOGIN} state={{ from: location }} replace />;
  }

  if (roles && !hasPermission(roles)) {
    return <Navigate to={PATHS.DASHBOARD} replace />;
  }

  return <Outlet />;
}

export default PrivateRoute;
